// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.video-call-modal[data-v-11cd51f0] {
  position: fixed;
  background: var(--11cd51f0-\\\$getStyles\\.modalBackground);
  border: var(--11cd51f0-\\\$getStyles\\.modalBorderWidth) solid var(--11cd51f0-\\\$getStyles\\.modalBorderColor);
  border-radius: var(--11cd51f0-\\\$getStyles\\.modalBorderRadius);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  animation: modalSlide-11cd51f0 0.3s ease-out;
  z-index: 9999;
}
@keyframes modalSlide-11cd51f0 {
from {
    opacity: 0;
    transform: scale(0.96) translateY(10px);
}
to {
    opacity: 1;
    transform: scale(1) translateY(0);
}
}
.video-call-modal.is-dragging[data-v-11cd51f0] {
  cursor: move;
}
.video-call-modal.is-maximized[data-v-11cd51f0] {
  width: calc(100vw - 40px) !important;
  height: calc(100vh - 40px) !important;
  left: 20px !important;
  top: 20px !important;
}
.video-call-modal.is-minimized[data-v-11cd51f0] {
  height: 45px !important;
  width: 280px !important;
}
.video-call-modal.is-minimized .modal-body[data-v-11cd51f0],
.video-call-modal.is-minimized .resize-handle[data-v-11cd51f0] {
  display: none;
}
.video-call-modal.is-fullscreen[data-v-11cd51f0] {
  width: 100vw !important;
  height: 100vh !important;
  left: 0 !important;
  top: 0 !important;
  border-radius: 0;
}
.modal-header[data-v-11cd51f0] {
  height: 45px;
  background: var(--11cd51f0-\\\$getStyles\\.modalBackground);
  border-radius: 10px 10px 0 0;
  cursor: move;
  user-select: none;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}
.video-call-modal.is-fullscreen .modal-header[data-v-11cd51f0] {
  border-radius: 0;
}
.header-content[data-v-11cd51f0] {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  padding: 0 14px;
}
.call-status[data-v-11cd51f0] {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.65);
}
.call-status.is-connecting[data-v-11cd51f0] {
  color: #1976d2;
}
.call-status.is-reconnecting[data-v-11cd51f0] {
  color: #f57c00;
}
.call-status.has-error[data-v-11cd51f0] {
  color: #d32f2f;
}
.call-info[data-v-11cd51f0] {
  display: flex;
  align-items: center;
  gap: 10px;
}
.call-icon[data-v-11cd51f0] {
  display: flex;
  align-items: center;
}
.recording-dot[data-v-11cd51f0] {
  animation: pulse-11cd51f0 2s infinite;
}
@keyframes pulse-11cd51f0 {
0%, 100% {
    opacity: 1;
}
50% {
    opacity: 0.5;
}
}
.call-title[data-v-11cd51f0] {
  font-size: 13px;
  font-weight: 600;
  color: #333;
}
.header-controls[data-v-11cd51f0] {
  display: flex;
  gap: 6px;
}
.header-btn[data-v-11cd51f0] {
  width: 28px;
  height: 28px;
  border: none;
  background: transparent;
  color: #666;
  cursor: pointer;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;
}
.header-btn[data-v-11cd51f0]:hover {
  background: rgba(0, 0, 0, 0.06);
  color: #333;
}
.close-btn[data-v-11cd51f0]:hover {
  background: rgba(244, 67, 54, 0.1);
  color: #f44336;
}
.video-call-modal.is-fullscreen .modal-body[data-v-11cd51f0] {
  border-radius: 0;
}
.no-media-content h3[data-v-11cd51f0] {
  color: #333;
  font-size: 20px;
  margin-bottom: 6px;
  font-weight: 600;
}
.no-media-content p[data-v-11cd51f0] {
  color: #666;
  font-size: 13px;
}
.connection-indicator i[data-v-11cd51f0] {
  width: 2px;
  height: 6px;
  background: #4caf50;
  border-radius: 1px;
  transition: all 0.2s ease;
}
.connection-indicator i[data-v-11cd51f0]:nth-child(2) {
  height: 9px;
}
.connection-indicator i[data-v-11cd51f0]:nth-child(3) {
  height: 12px;
}
.connection-indicator.medium i[data-v-11cd51f0] {
  background: #ff9800;
}
.connection-indicator.medium i[data-v-11cd51f0]:nth-child(3) {
  opacity: 0.3;
}
.connection-indicator.poor i[data-v-11cd51f0] {
  background: #f44336;
}
.connection-indicator.poor i[data-v-11cd51f0]:nth-child(2),
.connection-indicator.poor i[data-v-11cd51f0]:nth-child(3) {
  opacity: 0.3;
}
.resize-handle[data-v-11cd51f0] {
  position: absolute;
  user-select: none;
}
.resize-n[data-v-11cd51f0] {
  top: 0;
  left: 8px;
  right: 8px;
  height: 6px;
  cursor: ns-resize;
}
.resize-s[data-v-11cd51f0] {
  bottom: 0;
  left: 8px;
  right: 8px;
  height: 6px;
  cursor: ns-resize;
}
.resize-e[data-v-11cd51f0] {
  right: 0;
  top: 8px;
  bottom: 8px;
  width: 6px;
  cursor: ew-resize;
}
.resize-w[data-v-11cd51f0] {
  left: 0;
  top: 8px;
  bottom: 8px;
  width: 6px;
  cursor: ew-resize;
}
.resize-ne[data-v-11cd51f0] {
  top: 0;
  right: 0;
  width: 10px;
  height: 10px;
  cursor: nesw-resize;
}
.resize-nw[data-v-11cd51f0] {
  top: 0;
  left: 0;
  width: 10px;
  height: 10px;
  cursor: nwse-resize;
}
.resize-se[data-v-11cd51f0] {
  bottom: 0;
  right: 0;
  width: 10px;
  height: 10px;
  cursor: nwse-resize;
}
.resize-sw[data-v-11cd51f0] {
  bottom: 0;
  left: 0;
  width: 10px;
  height: 10px;
  cursor: nesw-resize;
}`, "",{"version":3,"sources":["webpack://./src/SharedWeb/scripts/apps/conversations/components/modals/VideoCallModal.vue","webpack://./VideoCallModal.vue"],"names":[],"mappings":"AAEA;EACE,eAAA;EACA,wDAAA;EACA,yGAAA;EACA,6DAAA;EACA,0EAAA;EACA,aAAA;EACA,sBAAA;EACA,4CAAA;EACA,aAAA;ACDF;ADIA;AACE;IACE,UAAA;IACA,uCAAA;ACDF;ADGA;IACE,UAAA;IACA,iCAAA;ACDF;AACF;ADIA;EACE,YAAA;ACFF;ADKA;EACE,oCAAA;EACA,qCAAA;EACA,qBAAA;EACA,oBAAA;ACFF;ADKA;EACE,uBAAA;EACA,uBAAA;ACFF;ADKA;;EAEE,aAAA;ACFF;ADKA;EACE,uBAAA;EACA,wBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;ACFF;ADKA;EACE,YAAA;EACA,wDAAA;EACA,4BAAA;EACA,YAAA;EACA,iBAAA;EACA,4CAAA;ACFF;ADKA;EACE,gBAAA;ACFF;ADKA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;ACFF;ADKA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,0BAAA;ACFF;ADKA;EACE,cAAA;ACFF;ADKA;EACE,cAAA;ACFF;ADKA;EACE,cAAA;ACFF;ADKA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;ACFF;ADKA;EACE,aAAA;EACA,mBAAA;ACFF;ADKA;EACE,qCAAA;ACFF;ADKA;AACE;IAEE,UAAA;ACHF;ADKA;IACE,YAAA;ACHF;AACF;ADMA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;ACJF;ADOA;EACE,aAAA;EACA,QAAA;ACJF;ADOA;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0BAAA;ACJF;ADOA;EACE,+BAAA;EACA,WAAA;ACJF;ADOA;EACE,kCAAA;EACA,cAAA;ACJF;ADOA;EACE,gBAAA;ACJF;ADOA;EACE,WAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;ACJF;ADOA;EACE,WAAA;EACA,eAAA;ACJF;ADOA;EACE,UAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;ACJF;ADOA;EACE,WAAA;ACJF;ADOA;EACE,YAAA;ACJF;ADOA;EACE,mBAAA;ACJF;ADOA;EACE,YAAA;ACJF;ADOA;EACE,mBAAA;ACJF;ADOA;;EAEE,YAAA;ACJF;ADOA;EACE,kBAAA;EACA,iBAAA;ACJF;ADOA;EACE,MAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,iBAAA;ACJF;ADOA;EACE,SAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,iBAAA;ACJF;ADOA;EACE,QAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;EACA,iBAAA;ACJF;ADOA;EACE,OAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;EACA,iBAAA;ACJF;ADOA;EACE,MAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;ACJF;ADOA;EACE,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;ACJF;ADOA;EACE,SAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;ACJF;ADOA;EACE,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;ACJF","sourcesContent":["@import \"@/styles/breakpoint-mixin.scss\";\n\n.video-call-modal {\n  position: fixed;\n  background: v-bind(\"$getStyles.modalBackground\");\n  border: v-bind(\"$getStyles.modalBorderWidth\") solid v-bind(\"$getStyles.modalBorderColor\");\n  border-radius: v-bind(\"$getStyles.modalBorderRadius\");\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.05);\n  display: flex;\n  flex-direction: column;\n  animation: modalSlide 0.3s ease-out;\n  z-index: 9999;\n}\n\n@keyframes modalSlide {\n  from {\n    opacity: 0;\n    transform: scale(0.96) translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n.video-call-modal.is-dragging {\n  cursor: move;\n}\n\n.video-call-modal.is-maximized {\n  width: calc(100vw - 40px) !important;\n  height: calc(100vh - 40px) !important;\n  left: 20px !important;\n  top: 20px !important;\n}\n\n.video-call-modal.is-minimized {\n  height: 45px !important;\n  width: 280px !important;\n}\n\n.video-call-modal.is-minimized .modal-body,\n.video-call-modal.is-minimized .resize-handle {\n  display: none;\n}\n\n.video-call-modal.is-fullscreen {\n  width: 100vw !important;\n  height: 100vh !important;\n  left: 0 !important;\n  top: 0 !important;\n  border-radius: 0;\n}\n\n.modal-header {\n  height: 45px;\n  background: v-bind(\"$getStyles.modalBackground\");\n  border-radius: 10px 10px 0 0;\n  cursor: move;\n  user-select: none;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.08);\n}\n\n.video-call-modal.is-fullscreen .modal-header {\n  border-radius: 0;\n}\n\n.header-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 100%;\n  padding: 0 14px;\n}\n\n.call-status {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: rgba(0, 0, 0, 0.65);\n}\n\n.call-status.is-connecting {\n  color: #1976d2;\n}\n\n.call-status.is-reconnecting {\n  color: #f57c00;\n}\n\n.call-status.has-error {\n  color: #d32f2f;\n}\n\n.call-info {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.call-icon {\n  display: flex;\n  align-items: center;\n}\n\n.recording-dot {\n  animation: pulse 2s infinite;\n}\n\n@keyframes pulse {\n  0%,\n  100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n}\n\n.call-title {\n  font-size: 13px;\n  font-weight: 600;\n  color: #333;\n}\n\n.header-controls {\n  display: flex;\n  gap: 6px;\n}\n\n.header-btn {\n  width: 28px;\n  height: 28px;\n  border: none;\n  background: transparent;\n  color: #666;\n  cursor: pointer;\n  border-radius: 5px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.15s ease;\n}\n\n.header-btn:hover {\n  background: rgba(0, 0, 0, 0.06);\n  color: #333;\n}\n\n.close-btn:hover {\n  background: rgba(244, 67, 54, 0.1);\n  color: #f44336;\n}\n\n.video-call-modal.is-fullscreen .modal-body {\n  border-radius: 0;\n}\n\n.no-media-content h3 {\n  color: #333;\n  font-size: 20px;\n  margin-bottom: 6px;\n  font-weight: 600;\n}\n\n.no-media-content p {\n  color: #666;\n  font-size: 13px;\n}\n\n.connection-indicator i {\n  width: 2px;\n  height: 6px;\n  background: #4caf50;\n  border-radius: 1px;\n  transition: all 0.2s ease;\n}\n\n.connection-indicator i:nth-child(2) {\n  height: 9px;\n}\n\n.connection-indicator i:nth-child(3) {\n  height: 12px;\n}\n\n.connection-indicator.medium i {\n  background: #ff9800;\n}\n\n.connection-indicator.medium i:nth-child(3) {\n  opacity: 0.3;\n}\n\n.connection-indicator.poor i {\n  background: #f44336;\n}\n\n.connection-indicator.poor i:nth-child(2),\n.connection-indicator.poor i:nth-child(3) {\n  opacity: 0.3;\n}\n\n.resize-handle {\n  position: absolute;\n  user-select: none;\n}\n\n.resize-n {\n  top: 0;\n  left: 8px;\n  right: 8px;\n  height: 6px;\n  cursor: ns-resize;\n}\n\n.resize-s {\n  bottom: 0;\n  left: 8px;\n  right: 8px;\n  height: 6px;\n  cursor: ns-resize;\n}\n\n.resize-e {\n  right: 0;\n  top: 8px;\n  bottom: 8px;\n  width: 6px;\n  cursor: ew-resize;\n}\n\n.resize-w {\n  left: 0;\n  top: 8px;\n  bottom: 8px;\n  width: 6px;\n  cursor: ew-resize;\n}\n\n.resize-ne {\n  top: 0;\n  right: 0;\n  width: 10px;\n  height: 10px;\n  cursor: nesw-resize;\n}\n\n.resize-nw {\n  top: 0;\n  left: 0;\n  width: 10px;\n  height: 10px;\n  cursor: nwse-resize;\n}\n\n.resize-se {\n  bottom: 0;\n  right: 0;\n  width: 10px;\n  height: 10px;\n  cursor: nwse-resize;\n}\n\n.resize-sw {\n  bottom: 0;\n  left: 0;\n  width: 10px;\n  height: 10px;\n  cursor: nesw-resize;\n}\n\n",".video-call-modal {\n  position: fixed;\n  background: v-bind(\"$getStyles.modalBackground\");\n  border: v-bind(\"$getStyles.modalBorderWidth\") solid v-bind(\"$getStyles.modalBorderColor\");\n  border-radius: v-bind(\"$getStyles.modalBorderRadius\");\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.05);\n  display: flex;\n  flex-direction: column;\n  animation: modalSlide 0.3s ease-out;\n  z-index: 9999;\n}\n\n@keyframes modalSlide {\n  from {\n    opacity: 0;\n    transform: scale(0.96) translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n.video-call-modal.is-dragging {\n  cursor: move;\n}\n\n.video-call-modal.is-maximized {\n  width: calc(100vw - 40px) !important;\n  height: calc(100vh - 40px) !important;\n  left: 20px !important;\n  top: 20px !important;\n}\n\n.video-call-modal.is-minimized {\n  height: 45px !important;\n  width: 280px !important;\n}\n\n.video-call-modal.is-minimized .modal-body,\n.video-call-modal.is-minimized .resize-handle {\n  display: none;\n}\n\n.video-call-modal.is-fullscreen {\n  width: 100vw !important;\n  height: 100vh !important;\n  left: 0 !important;\n  top: 0 !important;\n  border-radius: 0;\n}\n\n.modal-header {\n  height: 45px;\n  background: v-bind(\"$getStyles.modalBackground\");\n  border-radius: 10px 10px 0 0;\n  cursor: move;\n  user-select: none;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.08);\n}\n\n.video-call-modal.is-fullscreen .modal-header {\n  border-radius: 0;\n}\n\n.header-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 100%;\n  padding: 0 14px;\n}\n\n.call-status {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: rgba(0, 0, 0, 0.65);\n}\n\n.call-status.is-connecting {\n  color: #1976d2;\n}\n\n.call-status.is-reconnecting {\n  color: #f57c00;\n}\n\n.call-status.has-error {\n  color: #d32f2f;\n}\n\n.call-info {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.call-icon {\n  display: flex;\n  align-items: center;\n}\n\n.recording-dot {\n  animation: pulse 2s infinite;\n}\n\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n}\n.call-title {\n  font-size: 13px;\n  font-weight: 600;\n  color: #333;\n}\n\n.header-controls {\n  display: flex;\n  gap: 6px;\n}\n\n.header-btn {\n  width: 28px;\n  height: 28px;\n  border: none;\n  background: transparent;\n  color: #666;\n  cursor: pointer;\n  border-radius: 5px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.15s ease;\n}\n\n.header-btn:hover {\n  background: rgba(0, 0, 0, 0.06);\n  color: #333;\n}\n\n.close-btn:hover {\n  background: rgba(244, 67, 54, 0.1);\n  color: #f44336;\n}\n\n.video-call-modal.is-fullscreen .modal-body {\n  border-radius: 0;\n}\n\n.no-media-content h3 {\n  color: #333;\n  font-size: 20px;\n  margin-bottom: 6px;\n  font-weight: 600;\n}\n\n.no-media-content p {\n  color: #666;\n  font-size: 13px;\n}\n\n.connection-indicator i {\n  width: 2px;\n  height: 6px;\n  background: #4caf50;\n  border-radius: 1px;\n  transition: all 0.2s ease;\n}\n\n.connection-indicator i:nth-child(2) {\n  height: 9px;\n}\n\n.connection-indicator i:nth-child(3) {\n  height: 12px;\n}\n\n.connection-indicator.medium i {\n  background: #ff9800;\n}\n\n.connection-indicator.medium i:nth-child(3) {\n  opacity: 0.3;\n}\n\n.connection-indicator.poor i {\n  background: #f44336;\n}\n\n.connection-indicator.poor i:nth-child(2),\n.connection-indicator.poor i:nth-child(3) {\n  opacity: 0.3;\n}\n\n.resize-handle {\n  position: absolute;\n  user-select: none;\n}\n\n.resize-n {\n  top: 0;\n  left: 8px;\n  right: 8px;\n  height: 6px;\n  cursor: ns-resize;\n}\n\n.resize-s {\n  bottom: 0;\n  left: 8px;\n  right: 8px;\n  height: 6px;\n  cursor: ns-resize;\n}\n\n.resize-e {\n  right: 0;\n  top: 8px;\n  bottom: 8px;\n  width: 6px;\n  cursor: ew-resize;\n}\n\n.resize-w {\n  left: 0;\n  top: 8px;\n  bottom: 8px;\n  width: 6px;\n  cursor: ew-resize;\n}\n\n.resize-ne {\n  top: 0;\n  right: 0;\n  width: 10px;\n  height: 10px;\n  cursor: nesw-resize;\n}\n\n.resize-nw {\n  top: 0;\n  left: 0;\n  width: 10px;\n  height: 10px;\n  cursor: nwse-resize;\n}\n\n.resize-se {\n  bottom: 0;\n  right: 0;\n  width: 10px;\n  height: 10px;\n  cursor: nwse-resize;\n}\n\n.resize-sw {\n  bottom: 0;\n  left: 0;\n  width: 10px;\n  height: 10px;\n  cursor: nesw-resize;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
